/** Extract the first validation message for a DRF-style field error payload. */
export function getFirstApiFieldError(body: unknown, fieldName: string): string | undefined {
  if (body === null || typeof body !== 'object') {
    return undefined
  }

  const record = body as Record<string, unknown>
  const fieldError = record[fieldName]

  if (Array.isArray(fieldError)) {
    const first = fieldError.find((item) => typeof item === 'string')
    return typeof first === 'string' ? first : undefined
  }

  if (typeof fieldError === 'string') {
    return fieldError
  }

  return undefined
}
